import React from "react";
import { makeStyles } from "@material-ui/styles";
import { FruProButton } from "@components";

const useStyles = makeStyles((theme) => ({
  customButton: {
    width: "100%",
    height: "60px !important",
    fontWeight: 700,
    borderRadius: "20px !important",
    background: "transparent !important",
    border: `1px solid ${theme.palette.primary.primaryB} !important`,
  },
}));

export default function BackButton(props) {
  const classes = useStyles();
  return (
    <FruProButton
      color="initial"
      className={classes.customButton}
      noMargin
      {...props}
    >
      {props.children}
    </FruProButton>
  );
}
